module.exports = __webpack_public_path__ + "static/img/bgimg2.a778213a.jpg";